var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRank18 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 110,
  height: 103,
  viewBox: "0 0 110 103",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_ddd_1_399)"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_d_1_399)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23.924 76H35.732L47.786 17.944H39.094C37.782 21.224 35.896 23.602 33.272 25.078C30.648 26.554 27.45 27.292 23.514 27.292H22.448L20.808 35H32.37L23.924 76ZM59.7964 59.436C60.1244 58.124 60.4524 56.812 60.9444 55.582C61.4364 54.352 62.0104 53.286 62.6664 52.384C63.3224 51.482 64.1424 50.744 65.1264 50.252C66.1104 49.76 67.2584 49.432 68.6524 49.432C70.5384 49.432 71.8504 50.006 72.6704 50.99C73.4084 52.056 73.8184 53.45 73.8184 55.09C73.8184 56.894 73.5724 58.698 73.1624 60.42C72.7524 62.142 72.1784 63.7 71.4404 65.012C70.6204 66.324 69.6364 67.39 68.4884 68.21C67.3404 69.03 65.9464 69.44 64.4704 69.44C62.5024 69.44 61.1904 68.948 60.4524 67.882C59.6324 66.898 59.3044 65.504 59.3044 63.7C59.3044 62.47 59.4684 61.076 59.7964 59.436ZM66.1924 33.606C67.1764 28.358 69.6364 25.652 73.5724 25.652C76.5244 25.652 78.0004 27.292 78.0004 30.49C78.0004 32.458 77.7544 34.098 77.2624 35.492C76.7704 36.968 76.1964 38.116 75.4584 39.018C74.6384 40.002 73.8184 40.658 72.9164 41.068C71.9324 41.56 71.0304 41.724 70.2104 41.724C68.7344 41.724 67.6684 41.396 66.9304 40.576C66.1104 39.756 65.7824 38.526 65.7824 36.804C65.7824 36.066 65.8644 35 66.1924 33.606ZM47.9884 59.6C47.6604 61.076 47.4964 62.716 47.4964 64.438C47.4964 65.996 47.6604 67.554 48.0704 69.03C48.4804 70.506 49.3004 71.9 50.4484 73.048C51.5964 74.278 53.1544 75.262 55.1224 76C57.0904 76.82 59.7144 77.148 62.9124 77.148C66.3564 77.148 69.2264 76.738 71.6864 75.836C74.1464 75.016 76.1964 73.868 77.9184 72.474C79.5584 71.08 80.9524 69.522 81.9364 67.8C82.9204 66.16 83.6584 64.438 84.2324 62.798C84.7244 61.158 85.1344 59.682 85.2984 58.37C85.4624 57.058 85.5444 55.992 85.5444 55.254C85.5444 52.63 84.8884 50.498 83.7404 48.694C82.5104 46.972 80.6244 45.824 78.1644 45.25L78.2464 45.086C80.7064 44.594 82.6744 43.61 84.1504 42.216C85.6264 40.904 86.6924 39.428 87.5124 37.788C88.3324 36.148 88.8244 34.59 89.0704 32.95C89.3164 31.392 89.4804 30.08 89.4804 29.096C89.4804 25.16 88.1684 22.372 85.7084 20.568C83.1664 18.846 79.6404 17.944 75.2124 17.944C69.8824 17.944 65.4544 19.256 61.9284 21.716C58.3204 24.176 55.9424 28.276 54.7944 33.934C54.6304 34.426 54.5484 34.836 54.5484 35.246C54.4664 35.738 54.4664 36.148 54.4664 36.558C54.4664 37.542 54.5484 38.444 54.7944 39.264C54.9584 40.166 55.3684 40.986 55.8604 41.724C56.3524 42.544 57.0084 43.2 57.8284 43.774C58.6484 44.348 59.6324 44.758 60.8624 45.086L60.7804 45.25C57.3364 45.906 54.4664 47.546 52.3344 50.17C50.2024 52.794 48.7264 55.992 47.9884 59.6Z",
  fill: "#FAFAFA"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_ddd_1_399",
  x: -11,
  y: 0.94397,
  width: 120.48,
  height: 101.204,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 5
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 10
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_1_399"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 9
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_dropShadow_1_399",
  result: "effect2_dropShadow_1_399"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 6
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect2_dropShadow_1_399",
  result: "effect3_dropShadow_1_399"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect3_dropShadow_1_399",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_d_1_399",
  x: 16.808,
  y: 17.944,
  width: 76.6725,
  height: 67.204,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_1_399"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_1_399",
  result: "shape"
})))));
export default SvgRank18;